var app = angular.module('leonardo');

var TemplateTriggerFilters = function (
  $scope,
  CategoryCacheRestService,
  ReportService,
  $controller,
  PermissionService,
) {

$controller('FiltersBaseController', { $scope: $scope });

$scope.categories = [];

CategoryCacheRestService.getCategories().then(function(response) {

  if (response && response.length > 0) {
    $scope.categories = response.map(function(category) {
      return { id: category.id, name: category.name }; 
    });
  } else {
    console.warn('No categories found or invalid response');
    $scope.categories = []; 
  }
}, function(error) {
  console.error('Failed to fetch categories:', error);
  $scope.categories = []; 
});

$scope.$watch('categories', function(newValue) {
  if (newValue.length > 0) {
    const categoryFilter = $scope.filters_options.find(option => option.id === 'category');
    if (categoryFilter) {
      categoryFilter.options = newValue;
    }
  }
});



  $scope.filters_options = [
    {
      id: 'category',
      name: 'Category',
      label: null,
      inline: false,
      type: 'options',
      multiple: true,
      placeholder: 'All Categories',
      condition: true,
      options:$scope.categories,
      conflicts: ['sector']
    },
    {
      id: 'priority',
      name: 'Priority',
      label: null,
      inline: false,
      type: 'options',
      multiple: true,
      placeholder: 'All Priorities',
      condition: true,
      options: ReportService.PRIORITY_OPTIONS,
      conflicts: []
    },
    {
      id: 'template_name',
      name: 'Template name',
      label: null,
      inline: false,
      type: 'text',
      placeholder: 'Template name',
      condition: true,
      conflicts: [],
      onSubmit: $scope.filter
    },
    {
      id: 'role',
      name: 'Role',
      label: null,
      inline: false,
      type: 'options',
      multiple: true,
      options: $scope.authDataService.getRolesValid(),
      condition: PermissionService.isOwner(),
      conflicts: []
    }
  ];
};

app.controller('TemplateTriggerFilters', [
  '$scope',
  'CategoryCacheRestService',
  'ReportService',
  '$controller',
  'PermissionService',
  TemplateTriggerFilters
]);